<template>
    <div :title="header" id="CompatibilityImei">

        <template v-if="showCompatibility == false">

            <h5 v-if="!noDesc">¿Como obtener el IMEI de un dispositivo? 1</h5>

            <ol>
                <li>Ingresa a la marcación en el teléfono.</li>
                <li>Digita <strong>*#06#</strong> para obtener tu IMEI.</li>
                <li>Captura la respuesta completa en el campo inferior.</li>
            </ol>

            <b-form @submit="onSubmit">

                <b-form-group label="IMEI:">
                    <b-form-input v-model="form.imei" type="number" required placeholder=""></b-form-input>
                </b-form-group>

                <div class="text-right">
                    <div v-if="!isProcessing">
                        <b-button type="submit">
                            Consultar
                        </b-button>
                    </div>

                    <div v-else>
                        <b-button disabled>
                            Consultando...
                        </b-button>
                    </div>
                </div>


            </b-form>
        </template>

        <div class="row" v-else>
            <div class="col-12 col-imei-info">

                <div v-if="specifyByESim" class="text-center specify-by-e-sim">
                    <!-- <error-checkmark-component /> -->
                    <template v-if="('soportaESIM' in altanResponse.imei) && altanResponse.imei.soportaESIM == 'SI'">
                        <!-- <error-checkmark-component /> -->
                        <ui-dotlottie-loader aspect="3:2" />
                        <h5 class="tab-title">
                            El
                            {{ altanResponse.deviceFeatures.brand }}
                            {{ altanResponse.deviceFeatures.model }} 
                            soporta eSIM
                        </h5>
                    </template>
                    <template v-else>
                        <!-- <error-checkmark-component /> -->
                        <ui-dotlottie-loader aspect="3:1" lottie="wrong"/>
                        <h5 class="tab-title">
                            El
                            {{ altanResponse.deviceFeatures.brand }}
                            {{ altanResponse.deviceFeatures.model }} 
                            puede no ser compatible con eSIM
                        </h5>
                    </template>
                </div>

                <template v-else>
                    <div v-if="altanResponse.deviceFeatures.band28 == 'NO'" class="text-center">
                        <!-- <error-checkmark-component /> -->
                        <h5 class="tab-title">El
                            {{ altanResponse.deviceFeatures.brand }}
                            {{ altanResponse.deviceFeatures.model }}
                            no es compatible con nuestra red
                        </h5>
                    </div>
    
                    <div v-else-if="altanResponse.deviceFeatures.volteCapable == 'NO'" class="text-center">
                        <!-- <success-checkmark2-component/> -->
                        <h5 class="tab-title">
                            El {{ altanResponse.deviceFeatures.brand }}
                            {{ altanResponse.deviceFeatures.model }} es parcialmente compatible con la red de BlackFon®.
                        </h5>
                        <!-- <p>
                            Para la funcionlidad completa requiere <b>VozAPP</b>
                        </p> -->
                    </div>
    
                    <div v-else class="text-center">
                        <ui-dotlottie-loader aspect="3:2" v-if="!specifyByESim" />
                        <h5 class="tab-title">
                            El {{ altanResponse.deviceFeatures.brand }}
                            {{ altanResponse.deviceFeatures.model }}
                            es compatible con la red de BlackFon®.
                        </h5>
                    </div>
    
                </template>
                
                <b-tabs class="mt-4 mb-4">
                    <b-tab title="IMEI" aria-activedescendant="">
                        <!-- <h3 class="mb-4">IMEI</h3> -->
                        <b-table :items="beautifyObj(altanResponse.imei)" />
                    </b-tab>
                    <b-tab title="Características de hardware">
                        <!-- <h3 class="mb-4">Características de hardware</h3> -->
                        <b-table :items="beautifyObj(altanResponse.deviceFeatures)" />
                    </b-tab>
                </b-tabs>

                <div class="text-right">
                    <b-button variant="primary" @click="showCompatibility = false;">
                        Verificar otro dispositivo
                    </b-button>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
/**
 * Archivo original importado desde blackfon-web.
 * 
 * @author Daniel Lepe 2025
 * @version 1.0
 */
import _ from "lodash";
import Axios from "axios";
import mobiscroll from "@mobiscroll/javascript";
//   import errorCheckmarkComponent from "../shared/error-checkmark-component-1.vue";
//   import successCheckmark2Component from "../shared/success-checkmark-component-2.vue";

export default {
    name: 'CompatibilityImei',

    props: {
        specifyByESim: {
            type: Boolean,
            default: false
        },
        header: {
            type: String,
            default: 'Verifica la compatibilidad de tu dispositivo'
        },
        noDesc: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            showCompatibility: false,
            isProcessing: false,
            altanResponse: {

                imei: {
                    imei: null,
                    homologated: null,
                    blocked: null,
                    sub_category: null,
                    soportaESIM: null,
                },

                deviceFeatures: {
                    volteCapable: null,
                    band28: null,
                    model: null,
                    brand: null,
                },

            },

            form: {
                imei: "",
            },
        };
    },

    methods: {
        beautifyObj(obj) {
            let keyReLabel = (keyName) => {
                let renamers = {
                    imei: "IMEI",
                    homologated: "Homologado",
                    blocked: "Bloqueado",
                    sub_category: "Sub categoría",
                    soportaESIM: "Soporta eSIM",
                    volteCapable: "Soporta VolTE",
                    band28: "Banda 28",
                    model: "Modelo",
                    brand: "Marca",
                }
                return renamers[keyName]
            };
            return _.map(obj, (Dato, Valor) => {
                Valor = keyReLabel(Valor)
                return { Valor, Dato };
            });
        },
        async onSubmit(event) {
            event.preventDefault();

            // IS PROCESSING
            this.isProcessing = true;

            // TRYING
            try {
                let response = await Axios.get(
                    "consulta/imei/" + this.form.imei
                );

                // RESPONSE STATUS
                if (response.status) {
                    this.form.imei = "";
                    this.showCompatibility = true;
                    this.altanResponse = response.data;
                }

                // ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
                if (response.msg)
                    mobiscroll.snackbar({
                        display: "top",
                        theme: "ios",
                        message: response.msg,
                        color: response.class,
                        duration: 7000,
                    });

            } catch (e) {
                console.error(e);
            }

            // IS NOT
            this.isProcessing = false;
        },
    }
};
</script>

<style lang="scss">
@import '@/sass/utils/variables.scss';

#CompatibilityImei {
    
    .tab-title {
        text-align: center;
        color: $accent;
    }

    .nav {
        justify-content: center;
    }

    // .specify-by-e-sim {
    //     margin-bottom: 2em;
    //     padding-bottom: 2em;
    //     border-bottom: 1px solid $accent;
    // }

}
</style>